import { GenreProfile } from '@/types/production.types';

export const GENRE_PROFILES: GenreProfile[] = [
  // SOUTHERN ROCK
  {
    id: 'southern-rock',
    name: 'Southern Rock',
    keywords: ['southern rock', 'lynyrd skynyrd', 'allman brothers', 'swamp rock', 'georgia', 'dixie', 'boogie'],
    preferredKeys: ['E', 'A', 'G', 'D'],
    preferredModes: ['major', 'mixolydian', 'dorian'],
    tempoRange: [85, 130],
    suggestedTempo: 105,
    coreInstruments: ['electric-guitar-rhythm', 'electric-guitar-lead', 'bass-electric', 'drums-rock'],
    colorInstruments: ['hammond-b3', 'slide-guitar', 'piano-honkytonk'],
    textureInstruments: ['acoustic-guitar-strummed', 'harmonica'],
    mixStyle: 'wide-stereo',
    productionNotes: 'Dual guitar attack panned L/R. Hammond sits in the pocket. Drums punchy but roomy. Vocal forward and present.'
  },
  
  // OUTLAW COUNTRY
  {
    id: 'outlaw-country',
    name: 'Outlaw Country',
    keywords: ['outlaw country', 'waylon', 'willie', 'country rock', 'honky tonk', 'nashville rebel'],
    preferredKeys: ['E', 'A', 'D', 'G'],
    preferredModes: ['major', 'mixolydian'],
    tempoRange: [80, 120],
    suggestedTempo: 95,
    coreInstruments: ['acoustic-guitar-strummed', 'electric-guitar-twangy', 'bass-electric', 'drums-country'],
    colorInstruments: ['pedal-steel', 'fiddle', 'piano-honkytonk'],
    textureInstruments: ['harmonica', 'mandolin'],
    mixStyle: 'classic-stereo',
    productionNotes: 'Acoustic guitar foundation, pedal steel adds weep. Drums laid back in the pocket. Vocal dry and upfront.'
  },

  // MODERN COUNTRY
  {
    id: 'modern-country',
    name: 'Modern Country',
    keywords: ['modern country', 'contemporary country', 'country radio', '2020s country', 'mainstream country'],
    preferredKeys: ['G', 'D', 'A', 'E', 'C'],
    preferredModes: ['major', 'mixolydian'],
    tempoRange: [75, 130],
    suggestedTempo: 100,
    coreInstruments: ['acoustic-guitar-strummed', 'electric-guitar-twangy', 'bass-electric', 'drums-country'],
    colorInstruments: ['pedal-steel', 'fiddle', 'mandolin', 'piano-ballad'],
    textureInstruments: ['banjo', 'high-strung-acoustic', 'organ-b3'],
    mixStyle: 'polished-warm',
    productionNotes: 'Acoustic guitar foundation, electric for color. Vocal upfront and clear. Pedal steel for emotional moments. Modern polish with organic warmth.'
  },

  // BRO-COUNTRY
  {
    id: 'bro-country',
    name: 'Bro-Country',
    keywords: ['bro country', 'party country', 'country rock', 'arena country', 'tailgate', 'florida georgia line'],
    preferredKeys: ['E', 'A', 'D', 'G', 'B'],
    preferredModes: ['major', 'mixolydian'],
    tempoRange: [90, 140],
    suggestedTempo: 115,
    coreInstruments: ['electric-guitar-heavy', 'electric-guitar-rhythm', 'bass-heavy-pick', 'drums-rock'],
    colorInstruments: ['banjo', 'acoustic-guitar-strummed', 'piano-honkytonk'],
    textureInstruments: ['fiddle', 'synth-pad', 'gang-vocals'],
    mixStyle: 'loud-aggressive',
    productionNotes: 'Big loud guitars panned wide. Driving rock-influenced drums. Banjo hooks featured. Vocal powerful and upfront. Arena-ready anthems.'
  },

  // NASHVILLE COUNTRY
  {
    id: 'nashville-country',
    name: 'Nashville Country',
    keywords: ['nashville sound', 'countrypolitan', 'smooth country', 'classic country', 'country pop crossover', 'nashville'],
    preferredKeys: ['G', 'C', 'D', 'A', 'F'],
    preferredModes: ['major', 'minor'],
    tempoRange: [60, 110],
    suggestedTempo: 85,
    coreInstruments: ['piano-ballad', 'acoustic-guitar-fingerpicked', 'bass-electric-soft', 'drums-ballad'],
    colorInstruments: ['pedal-steel', 'strings-section', 'electric-guitar-clean'],
    textureInstruments: ['backing-vocals', 'harmonica', 'nylon-guitar'],
    mixStyle: 'lush-intimate',
    productionNotes: 'Piano and strings featured. Vocal intimate and warm. Pedal steel for emotion. Subdued drums. Lush backing vocals. Polished crossover appeal.'
  },
  
  // METAL
  {
    id: 'metal',
    name: 'Metal',
    keywords: ['metal', 'heavy metal', 'thrash', 'hard rock'],
    preferredKeys: ['E', 'D', 'A'],
    preferredModes: ['minor', 'phrygian', 'aeolian'],
    tempoRange: [100, 180],
    suggestedTempo: 140,
    coreInstruments: ['electric-guitar-heavy', 'bass-heavy-pick', 'drums-metal'],
    colorInstruments: ['electric-guitar-lead-shred'],
    textureInstruments: ['synthesizer-pad'],
    mixStyle: 'heavy-stereo',
    productionNotes: 'Wall of sound guitars, triggered drums for speed, aggressive bass definition.'
  },

  // GLAM METAL
  {
    id: 'glam-metal',
    name: 'Glam Metal',
    keywords: ['glam', 'glam metal', 'hair metal', '80s rock'],
    preferredKeys: ['E', 'A', 'D'],
    preferredModes: ['major', 'mixolydian'],
    tempoRange: [110, 145],
    suggestedTempo: 128,
    coreInstruments: ['electric-guitar-80s', 'bass-electric-bright', 'drums-arena'],
    colorInstruments: ['electric-guitar-lead-shred', 'synthesizer-pad-80s'],
    textureInstruments: ['backing-vocals'],
    mixStyle: 'gated-reverb',
    productionNotes: 'Huge gated snare, chorused guitars, soaring high vocals.'
  },

  // DOOM METAL
  {
    id: 'doom-metal',
    name: 'Doom Metal',
    keywords: ['doom', 'doom metal', 'stoner doom', 'sludge', 'sabbath', 'slow heavy'],
    preferredKeys: ['E', 'D', 'C', 'B'],
    preferredModes: ['minor', 'dorian', 'blues'],
    tempoRange: [40, 75],
    suggestedTempo: 55,
    coreInstruments: ['electric-guitar-heavy', 'electric-guitar-doom', 'bass-heavy', 'drums-doom'],
    colorInstruments: ['hammond-b3-dirty', 'synthesizer-pad'],
    textureInstruments: ['acoustic-guitar-dark', 'cello'],
    mixStyle: 'massive-mono',
    productionNotes: 'Guitars MASSIVE and center-weighted with slight L/R spread. Bass thunderous. Drums slow and deliberate. Vocal reverb-drenched and ominous.'
  },

  // FUNK / GROOVE
  {
    id: 'funk',
    name: 'Funk',
    keywords: ['funk', 'groove', 'disco'],
    preferredKeys: ['E', 'A', 'D'],
    preferredModes: ['dorian', 'mixolydian'],
    tempoRange: [90, 125],
    suggestedTempo: 110,
    coreInstruments: ['electric-guitar-funk', 'bass-slap', 'drums-funk'],
    colorInstruments: ['clavinet', 'horns-section'],
    textureInstruments: ['percussion'],
    mixStyle: 'tight-pocket',
    productionNotes: 'Everything locked in the pocket, percussive emphasis, minimal bleed.'
  },

  // GOSPEL
  {
    id: 'gospel',
    name: 'Gospel',
    keywords: ['gospel', 'soul', 'church'],
    preferredKeys: ['C', 'G', 'Ab', 'Eb'],
    preferredModes: ['major'],
    tempoRange: [60, 130],
    suggestedTempo: 85,
    coreInstruments: ['piano-gospel', 'hammond-b3-gospel', 'bass-gospel', 'drums-gospel'],
    colorInstruments: ['choir-subtle', 'horns-section'],
    textureInstruments: ['acoustic-guitar-strummed'],
    mixStyle: 'lush-ensemble',
    productionNotes: 'Massive vocal harmonies, rolling organ swells, building dynamic peaks.'
  },

  // AMERICANA / ROOTS
  {
    id: 'americana',
    name: 'Americana',
    keywords: ['americana', 'roots', 'folk', 'singer-songwriter'],
    preferredKeys: ['G', 'D', 'C', 'A'],
    preferredModes: ['major', 'mixolydian'],
    tempoRange: [70, 115],
    suggestedTempo: 92,
    coreInstruments: ['acoustic-guitar-strummed', 'acoustic-guitar-fingerpicked', 'bass-electric-soft', 'drums-country'],
    colorInstruments: ['fiddle', 'mandolin', 'harmonica'],
    textureInstruments: ['banjo', 'lap-steel'],
    mixStyle: 'organic-warm',
    productionNotes: 'Natural room acoustics, focus on wood textures, honest vocal delivery.'
  },

  // UNPLUGGED / ACOUSTIC
  {
    id: 'unplugged',
    name: 'Unplugged',
    keywords: ['unplugged', 'acoustic', 'acoustic guitar', 'acoustic piano'],
    preferredKeys: ['G', 'C', 'D', 'E'],
    preferredModes: ['major', 'minor'],
    tempoRange: [60, 105],
    suggestedTempo: 80,
    coreInstruments: ['acoustic-guitar-strummed', 'acoustic-guitar-fingerpicked', 'piano-ballad', 'bass-electric-soft'],
    colorInstruments: ['cello', 'harmonica'],
    textureInstruments: ['percussion-soft'],
    mixStyle: 'intimate-dry',
    productionNotes: 'Close-miking, audible breath and string noise, very intimate soundstage.'
  }
];

export function getMatchingGenres(keywords: string[]): GenreProfile[] {
  if (!keywords || keywords.length === 0) return [];
  const normalizedKeywords = keywords.map(k => k.toLowerCase());
  return GENRE_PROFILES.filter(genre => {
    const genreName = genre.name.toLowerCase();
    const genreKeywords = genre.keywords.map(k => k.toLowerCase());
    return normalizedKeywords.some(kw => 
      genreName.includes(kw) || kw.includes(genreName) ||
      genreKeywords.some(gk => gk.includes(kw) || kw.includes(gk))
    );
  });
}

export function getGenreById(id: string): GenreProfile | undefined {
  return GENRE_PROFILES.find(g => g.id === id);
}

export function blendGenreProfiles(genres: GenreProfile[]): {
  tempoRange: [number, number];
  suggestedTempo: number;
  preferredKeys: string[];
  preferredModes: string[];
  coreInstruments: string[];
  colorInstruments: string[];
} {
  if (genres.length === 0) {
    return {
      tempoRange: [80, 120],
      suggestedTempo: 100,
      preferredKeys: ['E', 'A', 'G'],
      preferredModes: ['major', 'minor'],
      coreInstruments: [],
      colorInstruments: []
    };
  }

  if (genres.length === 1) {
    const g = genres[0];
    return {
      tempoRange: g.tempoRange,
      suggestedTempo: g.suggestedTempo,
      preferredKeys: g.preferredKeys,
      preferredModes: g.preferredModes,
      coreInstruments: g.coreInstruments,
      colorInstruments: g.colorInstruments
    };
  }

  const minTempo = Math.max(...genres.map(g => g.tempoRange[0]));
  const maxTempo = Math.min(...genres.map(g => g.tempoRange[1]));
  const avgTempo = Math.round(genres.reduce((sum, g) => sum + g.suggestedTempo, 0) / genres.length);

  const keyFrequency: Record<string, number> = {};
  genres.forEach(g => {
    g.preferredKeys.forEach(k => {
      keyFrequency[k] = (keyFrequency[k] || 0) + 1;
    });
  });
  const preferredKeys = Object.entries(keyFrequency)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 4)
    .map(([key]) => key);

  const modeFrequency: Record<string, number> = {};
  genres.forEach(g => {
    g.preferredModes.forEach(m => {
      modeFrequency[m] = (modeFrequency[m] || 0) + 1;
    });
  });
  const preferredModes = Object.entries(modeFrequency)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([mode]) => mode);

  const coreSet = new Set<string>();
  const colorSet = new Set<string>();
  genres.forEach(g => {
    g.coreInstruments.forEach(i => coreSet.add(i));
    g.colorInstruments.forEach(i => colorSet.add(i));
  });

  return {
    tempoRange: [minTempo, maxTempo],
    suggestedTempo: Math.min(maxTempo, Math.max(minTempo, avgTempo)),
    preferredKeys,
    preferredModes,
    coreInstruments: Array.from(coreSet),
    colorInstruments: Array.from(colorSet)
  };
}